import { ScattergramForm } from "./scattergram_form";
import $ from "jquery";

// Extend the ScattergramPoint interface
interface TrendsScattergramPoint {
  x: number;
  y: number;
  id: string;
  name: string;
  labels: any;
  pointUrl: string;
  urlTemplate?: string;
  url?(): string;
}

class TrendsScattergramForm extends ScattergramForm {
  protected formElement(): JQuery {
    return $("#trends_form");
  }

  protected dimensionElement(): JQuery {
    return $("#dimension");
  }

  protected areaElement(): JQuery {
    return $("#area");
  }

  protected categoryElement(): JQuery {
    return $("#category");
  }

  getDimension(): string {
    return this.dimensionElement().val() as string;
  }

  getArea(): string {
    return this.areaElement().val() as string;
  }

  getCategory(): string {
    return this.categoryElement().val() as string;
  }

  private itemId(): string {
    return this.canvasElement().data("itemId");
  }

  getQuery(): Record<string, any> {
    return Object.assign({}, super.getQuery(), { item_id: this.itemId() });
  }

  protected fixPoint(point: any): any {
    point.x = Math.pow(point.x * 10, 2);
    const target = this.targetDate.stringValue();
    const dimension = this.getDimension();
    const area = this.getArea();
    const category = this.getCategory();

    point.url = function () {
      return (
        `${this.urlTemplate}?` +
        `selection%5B%5D=${this.id}&` +
        `type=kmr&` +
        `partition=monthly&` +
        `target=${encodeURIComponent(target)}&` +
        `max_rank=20&` +
        `aspect=0&` +
        `dimension=${dimension}&` +
        `area=${area}&` +
        `category=${category}`
      );
    };

    return point;
  }
}

export { TrendsScattergramForm, TrendsScattergramPoint };
